/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

define(['./winjs.base.raw'], function (winjs) {
	'use strict';
	return {
		Promise: winjs.Promise,
		TPromise: winjs.Promise,
		PPromise: winjs.Promise
	};
});



//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/base/common/winjs.base.js
// module id = 13
// module chunks = 0